import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import * as appDataActions from '../../../../actions/appDataActions';
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../../actions/dialogPopupActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as dataHelper from '../../../../helpers/dataHelper';
import * as userDataHelper from '../../../../helpers/userDataHelper';
import * as objectConstants from '../../../../constants/objectConstants';
import {MULTIPLE_ANSWER_REVIEW_CONFIG} from '../../../../models/dialogModels';
import * as keyboardConstants from '../../../../constants/keyboardConstants';

import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class MultipleAnswerOption extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            option: this.props.option,
            asset_id: this.props.asset_id,
            responseData: this.props.responseData,
            locale: appHelper.getLocalData(this.props.option),
            id: `${this.props.asset_id}_${this.props.option.option_id}`,
            ref: `ref_option_${this.props.option.option_id}`
        };
        this.showOption = this.showOption.bind(this);
        this.onOptionRevealed = this.onOptionRevealed.bind(this);
        this.removeOption = this.removeOption.bind(this);
        this.getDisabledState = this.getDisabledState.bind(this);
        this.getCheckedState = this.getCheckedState.bind(this);
        this.getOptionClass = this.getOptionClass.bind(this);
        this.onClickFunction = this.onClickFunction.bind(this);
        this.renderOption = this.renderOption.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.getScreenReaderOptionClass = this.getScreenReaderOptionClass.bind(this);
    }

    componentDidMount() {
        this.showOption(1, 0);
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.responseData !== nextProps.responseData){
            this.setState({responseData: Object.assign({},nextProps.responseData)});
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.option)
            });
        }
    }

    componentDidUpdate() {
    }

    onClickFunction(){
        if  (this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
            this.props.onShowReview();
        }
    }

    getOptionClass() {
		let checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions,"option_id", this.state.option.option_id);
		if(appHelper.isDefined(this.state.responseData.outcome.result) && checkedIndex > -1) {
			return `answered ${this.state.option.result}`;
		}
	}

	getScreenReaderOptionClass() {
		let checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions,"option_id", this.state.option.option_id);
		if(appHelper.isDefined(this.state.responseData.outcome.result) && checkedIndex > -1) {
			return appHelper.getOptionResultString(this.state.option.result,false);
		}
	}

    renderOption(){
        let responseData = this.state.responseData;
        let latestResponse = appHelper.getLastItemOfArray(responseData.responses);
        if (this.props.questionChecked && this.props.currentlyChecked) {
            let checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions,"option_id", this.state.option.option_id);
            if(appHelper.isDefined(this.state.responseData.outcome.result) && checkedIndex > -1) {
                return true;
            }else{
                return false;
            }
        }else{
            return true;
        }
    }

    getDisabledState() {
        if(appHelper.isDefined(this.state.responseData.outcome.result)){
            return `disabled`;
        }
        return null;
    }

    getCheckedState(){
        let checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions,"option_id", this.state.option.option_id);
        if(checkedIndex > -1){
            return `checked`;
        }
        return null;
    }


    showOption(duration, delay) {
        let optionRef = this.refs[this.state.ref];
        TweenLite.set(optionRef, {height: "auto", opacity: 1});
        TweenLite.from(optionRef, objectConstants.MC_OPTION_DURATION, {
            height: 0,
            opacity: 0,
            delay: delay,
            ease: Expo.easeInOut
        }).eventCallback("onComplete", this.onOptionRevealed);
    }

    onOptionRevealed(){
        this.props.onOptionRevealed(this.props.option);
    }

    removeOption() {
        //this.setState({render: false});
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            if(this.getDisabledState() !== 'disabled') {
                this.props.onOptionClick({target: {value: this.state.option.option_id}});
            }
        }
    }

    render() {
        return (
            this.renderOption()
            ?
                <div className={`multiple-choice-option ${this.state.option.choice_type} ${this.getOptionClass()}`} ref={this.state.ref} tabIndex="0" role="button" onKeyDown={this.setKeyboardAccessibility}>
                    <input id={this.state.id}
                           type="checkbox"
                           disabled={this.getDisabledState()}
                           checked={this.getCheckedState()}
                           name={this.state.id}
                           value={this.state.option.option_id}
                           onChange={this.props.onOptionClick}

                    />
                    <label htmlFor={this.state.id} >

                        <span dangerouslySetInnerHTML={{__html: this.state.locale.option}}/>
						<span className="hidden-el">{this.getScreenReaderOptionClass()}</span>
                    </label>
                </div>
            :
                null
        );
    }
}

MultipleAnswerOption.propTypes = {
    option: PropTypes.object.isRequired,
    asset_id:PropTypes.number.isRequired,
    questionChecked: PropTypes.bool.isRequired,
    currentlyChecked: PropTypes.bool.isRequired,
    responseData: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    onOptionClick: PropTypes.func,
    onAttemptComplete: PropTypes.func,
    onShowReview: PropTypes.func,
    onOptionRevealed: PropTypes.func,
    callbacks: PropTypes.object,
    contentData: PropTypes.object,
    trackingData: PropTypes.object,
    userData: PropTypes.object,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

MultipleAnswerOption.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MultipleAnswerOption);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/multipleAnswer/MultipleAnswerOption.js
 **/